import type { AccordionItemContent } from "@/types/sections";

// Approved bilingual service copy and the seven-panel visual order.
export const DEFAULT_SERVICE_ITEMS: AccordionItemContent[] = [
  {
    "id": "accordion-1",
    "title": {
      "fr": "The Circle",
      "en": "The Circle"
    },
    "imageUrl": "/images/sliders/6.webp",
    "color": "#FCD2C3",
    "iconKey": "UsersRound",
    "paragraphs": {
      "fr": [
        "Uncommon 12 propose à ses membres un accès privilégié à un réseau sélectionné de plus de 75 marques, adresses et lieux partenaires à Genève et dans la région.",
        "Les privilèges incluent :",
        "• Des réductions permanentes et tarifs préférentiels sur une sélection d’adresses",
        "• Des services offerts ou prestations additionnelles exclusives",
        "• Des invitations à des événements, expériences confidentielles et avant-premières",
        "• Des avantages négociés tout au long de l’année auprès de nos partenaires",
        "Un écosystème pensé pour enrichir le quotidien de nos membres et leur faire découvrir le meilleur de Genève et de sa région."
      ],
      "en": [
        "Uncommon 12 offers its members privileged access to a curated network of more than 75 selected brands, venues and partners across Geneva and the surrounding region.",
        "Privileges include:",
        "• Permanent discounts and preferential rates at selected addresses",
        "• Complimentary services and exclusive additional benefits",
        "• Invitations to private events, exclusive experiences and previews",
        "• Special privileges negotiated throughout the year with our partners",
        "An ecosystem designed to enrich our members’ everyday lives and help them discover the best of Geneva and its region."
      ]
    }
  },
  {
    "id": "accordion-2",
    "title": {
      "fr": "The Agenda",
      "en": "The Agenda"
    },
    "imageUrl": "/images/sliders/2.webp",
    "color": "#BBD8E6",
    "iconKey": "CalendarDays",
    "paragraphs": {
      "fr": [
        "Un calendrier d’événements originaux et intimistes, imaginés avec nos membres et partenaires autour de différents univers : business, culture, gastronomie, lifestyle, sport et bien-être.",
        "Au programme :",
        "• Dégustations, rencontres et expériences",
        "• Activités sportives, culturelles et sociales dédiées aux membres",
        "• Événements exclusifs organisés chez nos partenaires",
        "• Uncommon Talks et Business Lunches",
        "• Privatisations de lieux pour les événements Uncommon 12",
        "Les membres ont accès à l’ensemble des événements Uncommon 12, à l’exception des House Wednesdays, réservés aux membres Uncommon 12 + The House."
      ],
      "en": [
        "A calendar of original and intimate events, created with our members and partners across different worlds: business, culture, gastronomy, lifestyle, sport and wellbeing.",
        "The programme includes:",
        "• Tastings, encounters and experiences",
        "• Sporting, cultural and social activities dedicated to members",
        "• Exclusive events hosted by our partners",
        "• Uncommon Talks and Business Lunches",
        "• Private venues for Uncommon 12 events",
        "Members have access to all Uncommon 12 events, with the exception of House Wednesdays, reserved for Uncommon 12 + The House members."
      ]
    }
  },
  {
    "id": "accordion-3",
    "title": {
      "fr": "The Tailor",
      "en": "The Tailor"
    },
    "imageUrl": "/images/sliders/5.webp",
    "color": "#AED8C7",
    "iconKey": "ConciergeBell",
    "paragraphs": {
      "fr": [
        "Un service de conciergerie personnalisé pour accompagner nos membres dans leurs envies, projets et besoins personnels comme professionnels.",
        "The Tailor vous accompagne notamment pour :",
        "• L’organisation et la réservation de vos événements, déplacements ou prestations du quotidien",
        "• Des recommandations et réservations auprès de notre réseau d’adresses et partenaires",
        "• La coordination de projets privés ou corporate",
        "• Des demandes particulières nécessitant notre réseau ou notre connaissance de Genève",
        "Un service pensé pour faciliter votre quotidien et vous ouvrir les bonnes portes."
      ],
      "en": [
        "A personalised concierge service designed to assist our members with their personal and professional needs, projects and requests.",
        "The Tailor can assist with:",
        "• Organising and booking events, travel and everyday services",
        "• Recommendations and reservations within our network of selected addresses and partners",
        "• Coordination of private or corporate projects",
        "• Special requests drawing on our network and knowledge of Geneva",
        "A service designed to make everyday life easier and open the right doors."
      ]
    }
  },
  {
    "id": "accordion-6",
    "title": {
      "fr": "The Lounge",
      "en": "The Lounge"
    },
    "imageUrl": "https://firebasestorage.googleapis.com/v0/b/uncommon12-3c8c2.appspot.com/o/media%2F1763894736705-Lounge.png?alt=media&token=13c2fee5-cd61-40a2-881f-8eea7cfa1a01",
    "color": "#D8D1C2",
    "iconKey": "Martini",
    "paragraphs": {
      "fr": [
        "L’espace digital réservé aux membres Uncommon 12.",
        "Accessible directement depuis l’application du Club, The Digital Lounge permet de découvrir la communauté et de rester connecté avec les autres membres.",
        "Vous y retrouvez :",
        "• L’annuaire des membres Uncommon 12",
        "• Les adresses coup de cœur du Club à Genève",
        "• La Playlist des membres",
        "• Une messagerie interne permettant aux membres d’échanger directement entre eux",
        "Un espace pensé pour découvrir, échanger et prolonger l’expérience Uncommon 12 au quotidien."
      ],
      "en": [
        "The digital space exclusively reserved for Uncommon 12 members.",
        "Accessible directly through the Club app, The Digital Lounge allows members to discover the community and stay connected with one another.",
        "Inside, members can find:",
        "• The Uncommon 12 Members’ Directory",
        "• The Club’s favourite addresses in Geneva",
        "• The Members’ Playlist",
        "• An internal messaging service to communicate directly with other members",
        "A space designed to discover, connect and extend the Uncommon 12 experience every day."
      ]
    }
  },
  {
    "id": "accordion-base",
    "title": {
      "fr": "The Base — Rive Droite",
      "en": "The Base — Right Bank"
    },
    "imageUrl": "https://firebasestorage.googleapis.com/v0/b/uncommon12-3c8c2.appspot.com/o/media%2F1763894736705-Lounge.png?alt=media&token=13c2fee5-cd61-40a2-881f-8eea7cfa1a01",
    "color": "#F2E5CB",
    "iconKey": "Building2",
    "paragraphs": {
      "fr": [
        "Uncommon 12 dispose d’un QG Rive Droite au cœur de Base Geneva, boutique-hôtel contemporain situé à quelques minutes à pied de la gare Cornavin et du pont du Mont-Blanc.",
        "Un véritable lieu de vie pensé pour nos membres : travailler, se rencontrer, prendre un café, profiter du Rooftop ou simplement passer un moment.",
        "Nos membres bénéficient :",
        "• D’un accès au Café & Coworking",
        "• D’un accès au Rooftop",
        "• D’un accès à la salle de sport et au sauna",
        "• De tarifs préférentiels sur la réservation de chambres",
        "• De tarifs préférentiels sur les salles de réunion & conférence",
        "• De tarifs préférentiels pour la privatisation du Rooftop",
        "Une partie des événements et soirées Uncommon 12 est également organisée sur le Rooftop tout au long de l’année."
      ],
      "en": [
        "Uncommon 12 has its Right Bank HQ at Base Geneva, a contemporary boutique hotel located just a few minutes’ walk from Cornavin station and the Mont-Blanc bridge.",
        "A true home base designed for our members: a place to work, meet, have a coffee, enjoy the Rooftop or simply spend some time.",
        "Members enjoy:",
        "• Access to the Café & Coworking",
        "• Access to the Rooftop",
        "• Access to the gym and sauna",
        "• Preferential rates on hotel rooms",
        "• Preferential rates on Meeting & Conference Rooms",
        "• Preferential rates for Rooftop private hire",
        "A selection of Uncommon 12 events and evenings is also hosted on the Rooftop throughout the year."
      ]
    }
  },
  {
    "id": "accordion-house",
    "title": {
      "fr": "The House — Rive Gauche",
      "en": "The House — Left Bank"
    },
    "imageUrl": "https://firebasestorage.googleapis.com/v0/b/uncommon12-3c8c2.appspot.com/o/media%2F1763894736705-Lounge.png?alt=media&token=13c2fee5-cd61-40a2-881f-8eea7cfa1a01",
    "color": "#F2D5A3",
    "iconKey": "Utensils",
    "paragraphs": {
      "fr": [
        "La House Rive Gauche d’Uncommon 12, située au sein du restaurant Ripaille, Boulevard Helvétique 27.",
        "En partenariat avec Ripaille, les membres Uncommon 12 bénéficient d’un ensemble de privilèges exclusifs imaginés pour faire de Ripaille leur véritable House Rive Gauche.",
        "Un lieu où venir naturellement déjeuner, dîner, retrouver d’autres membres, recevoir ou simplement passer, avec une attention particulière réservée aux membres du Club.",
        "Certains mercredis soirs, les House Wednesdays seront exclusivement réservés aux membres.",
        "The House deviendra également l’un des rendez-vous événementiels d’Uncommon 12, avec une sélection de soirées, dîners, dégustations et événements organisés tout au long de l’année."
      ],
      "en": [
        "Uncommon 12’s Left Bank House, located within Ripaille restaurant at 27 Boulevard Helvétique.",
        "In partnership with Ripaille, Uncommon 12 members enjoy a collection of exclusive privileges designed to make Ripaille their very own Left Bank House.",
        "A place to naturally have lunch or dinner, meet other members, host guests or simply drop by, with special attention reserved for Club members.",
        "On selected Wednesday evenings, House Wednesdays are reserved exclusively for members.",
        "The House will also become one of Uncommon 12’s regular event destinations, hosting a selection of Club evenings, dinners, tastings and events throughout the year."
      ]
    }
  },
  {
    "id": "accordion-cigar-lounge",
    "title": {
      "fr": "The Cigar Lounge",
      "en": "The Cigar Lounge"
    },
    "imageUrl": "https://firebasestorage.googleapis.com/v0/b/uncommon12-3c8c2.appspot.com/o/media%2F1763894736705-Lounge.png?alt=media&token=13c2fee5-cd61-40a2-881f-8eea7cfa1a01",
    "color": "#ADA199",
    "iconKey": "Cigar",
    "paragraphs": {
      "fr": [
        "Un accès exclusif réservé aux membres Uncommon 12 à l’un des espaces les plus confidentiels de Genève : le Cigar Lounge de l’hôtel The Woodward.",
        "Installé dans l’ancien coffre-fort du bâtiment, le Cigar Lounge offre un cadre élégant et intimiste autour d’une sélection de cigares et spiritueux.",
        "Un lieu privilégié pour prendre un verre, partager un cigare, recevoir ou prolonger une soirée, au sein de l’un des hôtels les plus prestigieux de Genève."
      ],
      "en": [
        "Exclusive access for Uncommon 12 members to one of Geneva’s most intimate and distinctive spaces: The Cigar Lounge at The Woodward.",
        "Located within the building’s former bank vault, the Cigar Lounge offers an elegant and intimate setting with a selection of cigars and spirits.",
        "A privileged setting to enjoy a drink, share a cigar, host a guest or extend an evening, within one of Geneva’s most prestigious hotels."
      ]
    }
  }
];
